module.exports = __webpack_public_path__ + "img/category-zaimu.9a9fa239.svg";